import { useCallback } from "react";
import { Alert } from "../components/Alert";
import { useI18n } from "./i18n-hooks";
import { useMutation } from "@apollo/client";
import { DELETE_USER } from "../graphql/identity";
import auth from "../contexts/FirebaseAuth";
import { useSnackbar } from "./snackbar";

export const useDeleteAccount = () => {
    const i18n = useI18n();
    const [deleteUser] = useMutation(DELETE_USER);
    const { showSnackbar } = useSnackbar();

    const onDeleteAccount = useCallback(() => {
        Alert.alert(
            i18n.t("profile.delete_account_title"),
            i18n.t("profile.delete_account_description"),
            [
                {
                    text: i18n.t("profile.delete_account_confirm"),
                    onPress: () => {
                        const asyncFunc = async () => {
                            const deleteResult = await deleteUser();
                            if (deleteResult.data?.deleteUser) {
                                showSnackbar({
                                    text: i18n.t("profile.delete_account_success"),
                                    mode: "success",
                                });
                                void auth().signOut();
                            } else {
                                Alert.alert(
                                    i18n.t("profile.delete_account_error"),
                                    i18n.t("profile.delete_account_error_description"),
                                );
                            }
                        };
                        void asyncFunc();
                    },
                    style: "destructive",
                },
                {
                    text: i18n.t("cancel"),
                    style: "cancel",
                },
            ],
            { cancelable: true },
        );
    }, [i18n, deleteUser, showSnackbar]);

    return onDeleteAccount;
};
